import React from "react";
import { useEffect, useState, useRef } from "react";
import "./style.css";
import { BouncingLoader } from "../../pure-components/Loader";
import { Link } from "react-router-dom";
import Helper from "../../services/helper";
import defaultImage from "../../assets/default_music.png";

import { toast } from "react-toastify";
import { ErrorToast } from "../../pure-components/CustomToast";
import HarvestService from "../../services/harvestService";
import MediaTile from "../../components/Catalog/media-tile";
import sfxAlbumIds from "../../services/sfxAlbumIds.json"

const SFX = () => {
  
  const listRef = useRef(null);
  
  const sfxFilter = {
	"albumid": sfxAlbumIds.map(e => {
        return {"id" : e};
    })
}

  
  const [loading, setLoading] = useState(true);
  const [albumList, setAlbumList] = useState([]);
  const lastClickedKey = "lastClickedAlbumId";

  const [searchText,setSearchText] = useState("");
  const [sfxAlbums,setSfxAlbums] = useState([]);

  useEffect(() => {
      (async() => {
        await loadSFXAlbumList();
      })()
    
  }, [])

  const loadSFXAlbumList = async() => {
    setLoading(true);
    
    const reqObj = {
      refUrl : `/getalbumsbyids/{memberToken}`, 
      method : 'post',
      headers : {
          "Accept" : "application/json",
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
      },
      data : JSON.stringify(sfxFilter)
    };
    await HarvestService.loadHarvestData(reqObj).then((resp) => {
    //   console.log("SFX Albums : ", resp);
      const tempData = resp.Albums;
        //sorting on Name :
        if(tempData?.length > 0)
            tempData.sort((a, b) => {
            return a.Name.localeCompare(b.Name);
            })
    
        setSfxAlbums(tempData);
      setAlbumList(tempData);
    }).catch((err) => {
      console.log("SFX Data Loading Error : ", err);
      toast(({ closeToast }) => <ErrorToast message={"SFX Data loading Error."} />);
    }).finally(() => {
      setLoading(false);
    })
  }

  const handleSearch = async(e) => {
    
    if(e.key === 'Enter' && !loading){
      if(searchText?.length > 0){
        const filteredList = sfxAlbums?.filter((elem) => elem.Name?.toLowerCase().includes(searchText.toLowerCase()))
        setAlbumList(filteredList)
      }else{
        setAlbumList(sfxAlbums);
      }
    }
  };

  // Scroll to last clicked item after list loads

  const scrollToItem = (id) => {
    const el = document.getElementById(`${id}`);
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  };
  useEffect(() => {
    if (albumList.length === 0) return;

    const lastClickedId = sessionStorage.getItem(lastClickedKey);
    if (!lastClickedId) return;

    // wait for images
    const container = listRef.current;
    const images = container.querySelectorAll("img");

    let loadedCount = 0;

    if (images.length === 0) {
      scrollToItem(lastClickedId);
      return;
    }

    images.forEach((img) => {
      if (img.complete) {
        loadedCount++;
        if (loadedCount === images.length) scrollToItem(lastClickedId);
      } else {
        img.onload = () => {
          loadedCount++;
          if (loadedCount === images.length) scrollToItem(lastClickedId);
        };
        img.onerror = () => {
          loadedCount++;
          if (loadedCount === images.length) scrollToItem(lastClickedId);
        };
      }
    });
  }, [albumList]);
 
  return (
    
    <div ref={listRef} 
      className="sm:flex sm:flex-col sm:w-full lg:mx-auto p-5 bg-bg rounded-2xl"
      style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))", minHeight: "80vh", maxHeight : "80vh", overflowY:"scroll" }}
    >
      
    <div className="w-full flex mb-1">     
        <input id="sfx_search_box" className="w-full  p-1 pl-2 search-box search-icon rounded-full outline-none text-xs lg:text-base text-gray-600"
            onChange={event => { setSearchText(event.target.value) }}
            onKeyDown={handleSearch}
            placeholder="Search SFX Albums"
            disabled={loading}
            value={searchText}
            style={{"font-size": "13px", "height" : "36px"}} />
    </div>
        
    <div className="border-t my-2"></div>
    
    <div className="w-full">
      {loading && (
        <div className="w-full">
          <BouncingLoader />
        </div>
      )}
      {!loading && !(albumList?.length > 0) ? (
        <div className="text-lg sm:text-xl text-center text-red-500 my-5">
          No Album Found
        </div>
      ) : (
        <div 
          className="bg-white grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-2 sm:gap-2 md:gap-2 mt-2"
          style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))" }}
        >
          {albumList?.map((elem, index) => (
            <Link to={`/album/${elem?.ID}`} 
              key={elem?.ID} 
              id={elem?.ID} 
              onClick={() => {sessionStorage.setItem(lastClickedKey, elem?.ID)}}
              className="m-1"
            >
              
              <MediaTile
                style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))" }}
                image={Helper.getArtworkURL(elem?.ID) || defaultImage}
                title={elem?.Name || elem?.DisplayTitle}
                code=""
                description={elem?.Detail || elem?.DisplayTitle || elem?.Name}
                id={elem.ID}
              />
            </Link>
          ))}
        </div>
      )}
      
    </div>
  </div>
  );
};

export default SFX;